const moment = require("moment");
const { weekStart, shiftDay } = require("./dayNav.js");

const MODES = new Set(["day", "week", "month", "year"]);

function normalizeCalendarView(mode) {
  const m = mode == null ? "" : String(mode);
  return MODES.has(m) ? m : "day";
}

function shiftMonth(anchorDay, deltaMonths) {
  const m = moment(String(anchorDay), "YYYYMMDD");
  const day = m.date();
  m.add(Number(deltaMonths) || 0, "M");
  const max = m.daysInMonth();
  m.date(Math.min(day, max));
  return m.format("YYYYMMDD");
}

function shiftYear(anchorDay, deltaYears) {
  const src = moment(String(anchorDay), "YYYYMMDD");
  const month = src.month();
  const day = src.date();
  const m = moment({
    year: src.year() + (Number(deltaYears) || 0),
    month: 0,
    day: 1,
  });
  m.month(month);
  const max = m.daysInMonth();
  m.date(Math.min(day, max));
  return m.format("YYYYMMDD");
}

function monthGridDays(anchorDay, weekStartsOnMonday = true) {
  const monthStart = moment(String(anchorDay), "YYYYMMDD").startOf("month");
  const monthEnd = monthStart.clone().endOf("month");
  const gridStart = weekStart(monthStart.format("YYYYMMDD"), weekStartsOnMonday);
  let gridEnd = weekStart(monthEnd.format("YYYYMMDD"), weekStartsOnMonday);
  // include full last week
  gridEnd = shiftDay(gridEnd, 6);
  const days = [];
  for (let id = gridStart; ; id = shiftDay(id, 1)) {
    const inMonth = id.slice(0, 6) === monthStart.format("YYYYMM");
    days.push({ id, inMonth });
    if (id === gridEnd) break;
  }
  return days;
}

function monthDateRange(anchorDay, weekStartsOnMonday = true) {
  const cells = monthGridDays(anchorDay, weekStartsOnMonday);
  return { from: cells[0].id, to: cells[cells.length - 1].id };
}

function yearMonthStarts(anchorDay) {
  const y = moment(String(anchorDay), "YYYYMMDD").format("YYYY");
  return Array.from({ length: 12 }, (_, i) =>
    `${y}${String(i + 1).padStart(2, "0")}01`
  );
}

function dayHasTasks(list) {
  return Array.isArray(list) && list.length > 0;
}

module.exports = {
  monthGridDays,
  shiftMonth,
  shiftYear,
  yearMonthStarts,
  monthDateRange,
  dayHasTasks,
  normalizeCalendarView,
};
